// TOK philosophy — language rooted in African cosmology, Ubuntu,
// Afro-futurism, griot traditions and Black radical art philosophy.
//
// Use sparingly across the site so each line lands with weight.
// Avoid generic motivational tone — these are TOK's own mythology.

export const TOK_PHILOSOPHY = {
  // The recurring north-star statement.
  core: {
    line: "The role of the artist is to awaken the village.",
    attribution: "Temple of Kulture",
  },

  // Contextual lines — pick the one that suits the surface.
  lines: [
    {
      key: "unseen-world",
      line: "The unseen world is first created in the mind.",
      attribution: "TOK · Philosophy",
    },
    {
      key: "to-create",
      line: "To create is to remember what the spirit already knows.",
      attribution: "TOK · Philosophy",
    },
    {
      key: "without-stories",
      line: "A people without stories become invisible.",
      attribution: "TOK · Philosophy",
    },
    {
      key: "art-memory",
      line: "Art is memory made visible.",
      attribution: "TOK · Philosophy",
    },
    {
      key: "future-belongs",
      line: "The future belongs to those who can imagine beyond survival.",
      attribution: "TOK · Philosophy",
    },
    {
      key: "rhythm-image-story",
      line: "Through rhythm, image and story, we return to ourselves.",
      attribution: "TOK · Philosophy",
    },
    {
      key: "ubuntu",
      line: "I am because we are.",
      attribution: "Ubuntu",
    },
  ],
};

export const TOK_PHILOSOPHY_BY_KEY = Object.fromEntries(
  TOK_PHILOSOPHY.lines.map((l) => [l.key, l]),
);

// Helper — deterministic pick for footers / transitions that should
// vary per page but feel intentional rather than random.
export function pickPhilosophy(seed) {
  const lines = TOK_PHILOSOPHY.lines;
  if (typeof seed !== "string" || !seed) return lines[0];
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) {
    h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return lines[h % lines.length];
}
